import FeatureTypeList from "@/components/feature/FeatureTypCardGridView";
import type { LayoutContext } from "@/lib/models";
import { useEffect } from "react";
import { useOutletContext } from "react-router";

const HabitatTaskList: React.FC = () => {
  const { setPageName } = useOutletContext<LayoutContext>();

  useEffect(() => {
    setPageName('Habitat features'); // Set the page name when the component mounts
    return () => setPageName('Tasks List'); // Optional: Reset on unmount
  }, [setPageName]);

    return(
      <div className="container mx-auto p-4">
          <FeatureTypeList subType="Habitat" />
      </div>);
};

export default HabitatTaskList;